import { fabric } from "fabric"

const asyncLoadFabricImg = (src, options = {}) =>
  new Promise(resolve => {
    fabric.Image.fromURL(src, resolve, options)
  })

export const asyncSetBgImg = (canvas, img) =>
  new Promise(resolve => canvas.setBackgroundImage(img, resolve))

export default asyncLoadFabricImg
